import { isEmpty } from "lodash";
import moment from "moment";
import axios from "../axios";

export const uploadImage = async (file) => {
  var formData = new FormData();
  formData.append("media", file);
  try {
    const { data } = await axios.post("/auth/uploadImage", formData);

    return data;
  } catch (error) {}
};

export const extractDateForDOB = (e) => {
  if (e) {
    let extractDate = new Date(e).getDate() + "/" + new Date(e).getMonth() + "/" + new Date(e).getFullYear();
    return extractDate;
  } else {
    return "";
  }
};

export const extractDate = (e) => {
  if (e) {
    let date = new Date(e).toLocaleDateString();
    return date;
  } else {
    return "";
  }
};

export const joinStrs = (...strs) =>
  strs
    .filter(Boolean)
    .filter((str) => typeof str === "string")
    .join(" ");

const grpKeysIdMap = {
  "635bbb2ef1ee73ca2b2ab026": "price_and_ownership",
  "635bcc4eecd434ad5a3527b7": "taxes",
  "635bcd57ecd434ad5a3527c3": "lot_and_land_info",
  "635bbb4df1ee73ca2b2ab028": "building_and_exterior",
  "63b7be65a1a6bba3da17544b": "interior",
  "635bbb70f1ee73ca2b2ab02c": "foundation",
  "635cb3bec8fc739cc7950b27": "terms_and_compensation",
  "635cb16ac8fc739cc7950b07": "rooms",
};

export const getPropInpName = ({ prefix = "", stp, grp, inp }) => {
  let name = prefix ? prefix + "__" : "";
  name += prefix ? "" : stp ? "s" + stp + "__" : "";
  name += prefix ? "" : grp?._id ? getGrpNameMod(grpKeysIdMap[grp._id]) + "__" : "";
  // name += inp.inpColl?.length ? "coll_" : "";
  name += inp.input_name + "_" + inp._id;
  return name;
};

export const getIdFromPropInpName = (name = "") => name.split("__").pop().split("_").pop();

export const getGrpNameMod = (grp) => grpKeysIdMap[grp?._id] || null;

export const getLastElem = (arr) => arr[arr.length - 1];

export const getid = (v) => v?._id || v?.id;

export const getFieldValInStr = (val, config = {}) => {
  let retVal = "";

  if (config.isDate) {
    retVal = moment(val, "YYYY-MM-DD").format("DD/MM/YYYY");
  } else if (typeof val === "string" && !isEmpty(val)) {
    retVal = val;
  } else if (typeof +val === "number" && !isNaN(+val) && isFinite(+val)) {
    retVal = String(val);
  } else if (val instanceof Array && !isEmpty(val)) {
    retVal = val.map((v) => v.label).join(",");
  } else if (typeof val === "object" && "label" in val && !isEmpty(val.label)) {
    retVal = val.label;
  }

  return retVal;
};

export const formatPrice = (p) =>
  new Intl.NumberFormat("en", {  notation: "compact" }).format(p);
// new Intl.NumberFormat("en", { style: "currency", currency: c||"IQD", notation: "compact" }).format(p);

export const togInArr = ([...arr], el) => {
  const idx = arr.indexOf(el);

  if (idx > -1) {
    arr.splice(idx, 1);
    return arr;
  } else {
    return [...arr, el];
  }
};

/**
 * @param {{ lat: number, lng: number }} coords1
 * @param {{ lat: number, lng: number }} coords2
 * @param {'km' | 'mile'} unit
 */
export const calcCoordsDist = ({ lat: lat1, lng: lon1 }, { lat: lat2, lng: lon2 }, unit = "km") => {
  const pk = 180 / Math.PI;
  const a1 = lat1 / pk;
  const a2 = lon1 / pk;
  const b1 = lat2 / pk;
  const b2 = lon2 / pk;
  const t1 = Math.cos(a1) * Math.cos(a2) * Math.cos(b1) * Math.cos(b2);
  const t2 = Math.cos(a1) * Math.sin(a2) * Math.cos(b1) * Math.sin(b2);
  const t3 = Math.sin(a1) * Math.sin(b1);
  const tt = Math.acos(t1 + t2 + t3);
  return (((6366000 * tt) / 1000) * (unit === "km" ? 1 : unit === "mile" ? 0.621371 : 1).toFixed(2)).toFixed(2) + ` ${unit}s`;
};

export const toggleVal = (prevVal, newVal, noVal = null) => (prevVal === newVal ? noVal : newVal);
